import { AcknowledgementName } from "@wingspanhq/wingspan-api-sdk";

export type IAcknowledgements = AcknowledgementName[];

export enum WalletCardType {
  Physical = "physical",
  Virtual = "virtual"
}
